import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/banner2/11-2.png'
import _imports_1 from '../assets/img/delstep.svg'
import _imports_2 from '../assets/img/addstep.svg'
import _imports_3 from '../assets/img/introduction/nowStep.svg'
import _imports_4 from '../assets/img/introduction/step.svg'
import _imports_5 from '../assets/img/introduction/nowStep2.svg'
import _imports_6 from '../assets/img/introduction/Vector.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-4c18398f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"banner\" data-v-4c18398f><div class=\"banner-center\" data-v-4c18398f><div class=\"textbox\" data-v-4c18398f><div class=\"banner-text1\" data-v-4c18398f>远程异地评标和评标专家库共享技术标准</div><div class=\"banner-text2\" data-v-4c18398f>助力建设全国统一大市场，优化市场营商环境</div></div><div data-v-4c18398f><img src=\"" + _imports_0 + "\" alt=\"\" class=\"banner-img\" data-v-4c18398f></div></div></div>", 1)
const _hoisted_2 = { class: "box0" }
const _hoisted_3 = {
  class: "center",
  style: {"position":"relative"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  style: {"width":"16px","height":"16px"}
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  style: {"width":"16px","height":"16px"}
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "filebox" }
const _hoisted_9 = { class: "filebox-item" }
const _hoisted_10 = { class: "fileImg" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "fileContent" }
const _hoisted_13 = { class: "fileTitle" }
const _hoisted_14 = { class: "fileText" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "filebox-item" }
const _hoisted_17 = { class: "fileImg" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "fileContent" }
const _hoisted_20 = { class: "fileTitle" }
const _hoisted_21 = { class: "fileText" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "box1" }
const _hoisted_24 = {
  class: "bigcenter",
  style: {"position":"relative"}
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  style: {"width":"16px","height":"16px"}
}, null, -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  style: {"width":"16px","height":"16px"}
}, null, -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { class: "step" }
const _hoisted_30 = {
  key: 0,
  class: "yearInfoBox2"
}
const _hoisted_31 = { class: "title" }
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = {
  key: 1,
  class: "yearInfoBox"
}
const _hoisted_34 = { class: "title" }
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = { class: "year" }
const _hoisted_37 = { class: "steppoint2" }
const _hoisted_38 = {
  key: 0,
  src: _imports_3,
  alt: ""
}
const _hoisted_39 = {
  key: 1,
  src: _imports_4,
  alt: "",
  style: {"width":"12px","height":"12px"}
}
const _hoisted_40 = {
  key: 2,
  class: "nowStep"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
}, null, -1))
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = { class: "box2" }
const _hoisted_44 = /*#__PURE__*/_createStaticVNode("<div class=\"center\" data-v-4c18398f><div class=\"textbox\" data-v-4c18398f><img src=\"" + _imports_6 + "\" alt=\"\" class=\"textico\" data-v-4c18398f><div class=\"text-item\" data-v-4c18398f> 基于中国招标投标公共服务平台、各省级招标投标公共服务平台、电子招标投标监督系统、电子招标投标交易系统、电子评标专业工具、场所运行管理系统、场所工位预约工具、专家库管理系统、会议交流工具等共建、共治、共享的公共网络服务体系，通过共享目录和“点对点”互联机制，实现专家库资源、评标场地资源和场地音视频互联互通。 </div></div><div class=\"textbox\" data-v-4c18398f><img src=\"" + _imports_6 + "\" alt=\"\" class=\"textico\" data-v-4c18398f><div class=\"text-item\" data-v-4c18398f> 为推进远程异地评标便捷、高效开展，需要以电子招标采购网络为基础，进一步拓展延伸建立专家库、评标场地、音视频等互联网络体系，实现专家库资源、评标场地资源和场地音视频互联互通。实现以经营主体为中心，按需抽取专家、自主预订场地，专家通过视频会议实时在线交流，监督人员全程实时在线监督。 </div></div></div>", 1)
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_46 = { class: "list-main" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

import { reactive, toRefs, ref, onMounted } from 'vue'
import mytitle from '../components/title.vue'
import { useRouter } from "vue-router";
// import { getNews } from '../utils/axios/index2.ts'
import StandardCard from '../components/standard/standard-card'
import { getRemoteBidEvaluationDocument, newEndpointDownload } from '../utils/axios/index.js'
import { ElMessage } from 'element-plus'

import { getStandard, getNews, getEndpointCount } from '../utils/axios'
//文件轮播
import fileImg from '../assets/img/introduction/file-img0.png'

import fileImg1 from '../assets/img/introduction/file-img1.png'
import fileImg2 from '../assets/img/introduction/file-img2.png'

// 技术标准

export default /*#__PURE__*/_defineComponent({
  __name: 'introduction',
  setup(__props) {

const myCarousel = ref(null);

// 上一个
const prevCarousel = () => {
    if (myCarousel.value) {
        myCarousel.value.prev();
    }

}
// 下一个
const nextCarousel = () => {
    if (myCarousel.value) {
        myCarousel.value.next();
    }

}


//文件图片
const guides = ref([
    { title: '远程异地评标技术标准<br>电子交易系统接入指南', type: 1, name: 'S01远程异地评标和评标专家库共享技术标准_电子交易系统接入指南_20250605_1600' },
    
    { title: '远程异地评标技术标准<br>电子评标工具接入指南', type: 2, name: 'S02远程异地评标和评标专家库共享技术标准_电子评标工具接入指南_20250605_1600' },

    { title: '远程异地评标技术标准<br>场地视频会议系统接入指南', type: 5, name: 'L02远程异地评标和评标专家库共享技术标准_场地视频会议系统接入指南_20250605_1600' },


    { title: '远程异地评标技术标准<br>场地管理系统接入指南', type: 3, name: 'S03远程异地评标和评标专家库共享技术标准_场地管理系统接入指南_20250605_1600' },

    { title: '远程异地评标技术标准<br>场地音视频监控工具接入指南', type: 4, name: 'S04 远程异地评标和评标专家库共享技术标准_场地音视频监控工具接入指南_20250605_1600' },

    { title: '远程异地评标技术标准<br>专家库管理系统接入指南', type: 6, name: 'S05远程异地评标和评标专家库共享技术标准_专家库管理系统接入指南_20250605_1600' },

    { title: '远程异地评标技术标准<br>专家抽取终端接入指南', type: 7, name: 'S09远程异地评标和评标专家库共享技术标准_专家抽取终端接入指南_20250605_1600' },


])

// 技术标准展示数据
const standards = ref([
    {
        title: '远程异地评标<br>服务规范',
        type: 13,
        desc: {
            title: '面向各类平台、系统的运营方，在服务内容及使用流程',
            texts: [
                '规定远程异地评标的标准术语和定义',
                '基本原则',
                '远程异地评标架构',
                '服务内容与要求',
            ]
        }
    },
    {
        title: '远程异地评标<br>技术规范',
        type: 14,

        desc: {
            title: '面向各类平台、系统的运营方，在技术路线和功能实现',
            texts: [
                '规定远程异地评标的功能要求',
                '交互接口设计要求',
                '非功能性技术要求',
                '运行环境要求',
            ]
        }
    },
    {
        title: '远程异地评标<br>数据规范',
        type: 15,

        desc: {
            title: '面向跨应用数据共享方，在数据交互',
            texts: [
                '规定了电子交易系统、电子评标工具、场所运行管理系统、会议系统、环境音视频监控工具对接实现远程异地评标的数据要求',

            ]
        }
    },

    {
        title: '评标专家库共享<br>服务规范',
        type: 16,
        desc: {
            title: '面向专家库管理系统运营方，在服务内容及使用流程',
            texts: [
                '规定网络互联共享评标专家库的标准术语和定义',
                '基本原则',
                '网络互联共享评标专家库架构',
                '服务内容与要求',
            ]
        }
    },
    {
        title: '评标专家库共享<br>技术规范',
        type: 17,
        desc: {
            title: '面向专家库管理系统运营方，在技术路线和功能实现',
            texts: [
                '规定网络互联共享评标专家库的功能要求',
                '交互接口设计要求',
                '非功能性技术要求',
                '运行环境要求',
            ]
        }
    },
    {
        title: '评标专家库共享<br>数据规范',
        type: 18,
        desc: {
            title: '面向跨应用数据共享方，在数据交互',
            texts: [
                '规定了专家库管理系统对接实现网络互联共享评标专家库的数据要求',

            ]
        }
    },
])
//文件列表

let fileList = ref([
    [
        { title: '发改办法规〔2021〕24号', text: '《国务院关于开展营商环境创新试点工作的意见》', url: 'https://www.gov.cn/zhengce/content/202405/content_6949845.htm', img: fileImg1 },

        { title: '发改办法规〔2023〕54号', text: '《国家发展改革委关于在部分地方公共资源交易平台和企业招标采购平台试运行招标投标领域数字证书跨区域兼容互认功能的通知》', url: 'https://zfxxgk.ndrc.gov.cn/web/iteminfo.jsp?id=20445', img: fileImg2 },
    ],


])
const parentRef = ref(null);

// 滚动偏移量  
const scrollOffset = ref(0);
//当前年份
let nowStep = ref(2013)

//下一个年份

const addstep = () => {

    let now = {}
    yearList.value.map((element, index) => {
        if (element.year == nowStep.value) {
            if (index + 1 < yearList.value.length) {
                now = yearList.value[index + 1]
            }
            if (scrollOffset.value < 0) {
                scrollOffset.value += 240;

            }



        }
    });

    if (now.year) {
        nowStep.value = now.year
    }



}
//上一个年份

const delstep = () => {
    yearList.value.map((element, index) => {
        if (element.year == nowStep.value) {
            if (index - 1 >= 0) {
                nowStep.value = yearList.value[index - 1].year
            }
            if (scrollOffset.value > 2) {
                scrollOffset.value -= 240;
            }


        }
    });
}


//年份信息
let yearList = ref([




    { year: 2013, title: '首次提出设立专家库，实现专家资源共享', text: '《电子招标投标办法》（20号令）提出：公共服务平台要连接依法设立的评标专家库，实现专家资源共享。随后多次在政策中提出要推广远程异地评标，要求越加明确。' },
    { year: 2019, title: '通过远程异地评标推动专家资源跨地区、跨行业共享', text: '《关于深化公共资源交易平台整合共享的指导意见》（41号文）要求健全公共资源交易平台系统，通过远程异地评标、评审等方式加快推动优质专家资源跨地区、跨行业共享，优化专家抽取服务。' },
    { year: 2020, title: '完善远程异地评标系统及\n' + '技术规范', text: '国家发展改革委下发的《关于积极应对疫情创新做好招投标工作保障经济平稳运行的通知》，明确提出“积极推广电子评标和远程异地评标”，要求“各地要加快建设完善电子评标系统，应用信息化工具辅助评标，提高评标效率；完善远程异地评标系统及技术规范，尽早实现省内常态化运行，并为跨省运行创造条件，有效减少评标人员聚集，实现有限专家资源充分共享”。' },

    { year: 2022, title: '积极推广网络远程异地评标', text: '国家发展改革委下发《国家发展改革委等部门关于严格执行招标投标法规制度进一步规范招标投标主体行为的若干意见》提到严格规范和优化评标组织方式。积极推广网络远程异地评标，打破本地评标专家“小圈子”，推动优质专家资源跨省市、跨行业互联共享。' },

    { year: 2024, title: '全面推广远程异地评标', text: '国务院办公厅下发《关于创新完善体制机制推动招标投标市场规范健康发展的意见》，全面推广网络远程异地评标。推行隐藏投标人信息的暗标评审。积极试行投标人资格、业绩、信用等客观量化评审，提升评标质量效率。' },


])

//文字加粗
yearList.value.forEach(item => {
    // 使用正则表达式找到所有被《》包围的文本（包括书名号）  
    // const regex = /(《([^《》]*)》)/g;
    const regex = /\（(.*?)\）|《(.*?)》/g;

    // 替换匹配到的文本（包括书名号）为带有加粗样式的HTML  
    item.text = item.text.replace(regex, (match, p1) => `<span style="color: #323335;font-weight: 600;">${match}</span>`);
});









const router = useRouter();

const tonews = () => {
    // router.push({ path: '/news' })
}
//to新闻详情
const tonewslink = (url) => {
    // window.open(url, '_blank');
}
// 互认概览统计数量
let allNum = ref({
    appCount: 0,
    caOrgCount: 0,
    platformCount: 0,
    sealOrgCount: 0,
})

onMounted(() => {

    // //获取新闻列表
    // getNews({}).then(res => {
    //     newsList.value = res.data.records


    // }).catch(err => {

    // })

    // // 互认概览统计数量

    // getEndpointCount({}).then(res => {
    //     allNum.value = res.data
    //     // let nowUrl = window.location.href
    //     // if (nowUrl.includes('cashare.cebpubservice.com')) {
    //     //     //生产环境置空
    //     //     allNum.value.platformCount = 0
    //     // }

    // }).catch(err => {

    // })

})

let newsList = ref([{ newsTitle: '国家发展改革办公厅等关于展开工程建设招标投标领域突出问题专项治理的通知', publishTime: '2024-07-11' }])




let nowfile = ref(1)

//跳转文件地址

const tofile = (url) => {

    window.open(url, '_blank');

}

// 预览 
const previewGuide = (item: any) => {
    // getRemoteBidEvaluationDocument({ documentType: item.type }).then(res => {
    //     if(!res.data.documentUrl){
    //         ElMessage.warning('功能开发中，敬请期待！')
    //     }
    //     window.open(res.data.documentUrl, '_blank');

    // }).catch(res => {
    //     ElMessage.warning('功能开发中，敬请期待！')
    // })
    // window.open('远程异地评标和评标专家库共享技术标准_专家库管理系统和专家抽取终端接入指南.pdf', '_blank');
    // console.log(item.name);
    if (item.type == '1') {
        window._czc.push(['_trackEvent', '技术标准简介', '预览', '电子交易系统接入指南预览'])
    }
    if (item.type == '2') {
        window._czc.push(['_trackEvent', '技术标准简介', '预览', '电子评标工具接入指南预览'])
    }
    if (item.type == '3') {
        window._czc.push(['_trackEvent', '技术标准简介', '预览', '场地视频会议系统接入指南预览'])
    }
    if (item.type == '4') {
        window._czc.push(['_trackEvent', '技术标准简介', '预览', '场地管理系统接入指南预览'])
    }
    if (item.type == '5') {
        window._czc.push(['_trackEvent', '技术标准简介', '预览', '场地音视频监控工具接入指南预览'])
    }
    if (item.type == '6') {
        window._czc.push(['_trackEvent', '技术标准简介', '预览', '专家库管理系统和专家抽取终端接入指南预览'])
    }
    if (item.type == '7') {
        window._czc.push(['_trackEvent', '技术标准简介', '预览', '集成专家库共享抽取工具指南预览'])
    }
    window.open(item.name + '.pdf', '_blank');

   

}


// 下载 
const downloadGuide = (item: any) => {
    // let name2 = ''
    // getRemoteBidEvaluationDocument({ documentType: item.type }).then(res => {
    //     if(!res.data.documentUrl){
    //         ElMessage.warning('功能开发中，敬请期待！')
    //     }
    //     name2 = res.data.documentName
    //     let url = res.data.name
    //     newEndpointDownload({ contentDisposition: 'attachment', filePath: url }).then(res => {
    //         var blob = new Blob([res])
    //         let fname = name2 + '.pdf'; //下载文件的名字
    //         if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    //             window.navigator.msSaveOrOpenBlob(blob, fname);
    //         } else {
    //             let objectUrl = URL.createObjectURL(blob);
    //             let link = document.createElement("a");
    //             link.href = objectUrl;
    //             link.setAttribute("download", fname);
    //             document.body.appendChild(link);
    //             link.click();
    //         }
    //     })



    // }).catch(res => {
    //     ElMessage.warning('功能开发中，敬请期待！')
    // })

    const a = document.createElement('a')
    a.href = item.name + '.pdf'
    a.download = item.name + '.pdf'
    a.click()



    if (item.type == '1') {
        window._czc.push(['_trackEvent', '技术标准简介', '下载', '电子交易系统接入指南下载'])
    }
    if (item.type == '2') {
        window._czc.push(['_trackEvent', '技术标准简介', '下载', '电子评标工具接入指南下载'])
    }
    if (item.type == '3') {
        window._czc.push(['_trackEvent', '技术标准简介', '下载', '场地视频会议系统接入指南下载'])
    }
    if (item.type == '4') {
        window._czc.push(['_trackEvent', '技术标准简介', '下载', '场地管理系统接入指南下载'])
    }
    if (item.type == '5') {
        window._czc.push(['_trackEvent', '技术标准简介', '下载', '场地音视频监控工具接入指南下载'])
    }
    if (item.type == '6') {
        window._czc.push(['_trackEvent', '技术标准简介', '下载', '专家库管理系统和专家抽取终端接入指南下载'])
    }
    if (item.type == '7') {
        window._czc.push(['_trackEvent', '技术标准简介', '下载', '集成专家库共享抽取工具指南下载'])
    }






}



return (_ctx: any,_cache: any) => {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(mytitle, { title: "政策文件" }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "delStep",
          style: {"position":"absolute","left":"-50px","top":"160px"},
          onClick: prevCarousel
        }, _hoisted_5),
        _createElementVNode("div", {
          class: "delStep",
          style: {"position":"absolute","right":"-50px","top":"160px"},
          onClick: nextCarousel
        }, _hoisted_7),
        _createVNode(_component_el_carousel, {
          "indicator-position": "none",
          style: {"width":"100%","margin-top":"72px"},
          arrow: "never",
          ref_key: "myCarousel",
          ref: myCarousel
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fileList), (item, index) => {
              return (_openBlock(), _createBlock(_component_el_carousel_item, { key: index }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("img", {
                          src: item[0].img,
                          alt: "",
                          style: {"width":"120px","height":"160px"}
                        }, null, 8, _hoisted_11)
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, _toDisplayString(item[0].title), 1),
                        _createElementVNode("div", _hoisted_14, _toDisplayString(item[0].text), 1),
                        _createElementVNode("div", {
                          class: "tofile",
                          onClick: ($event: any) => (tofile(item[0].url

                                    ))
                        }, "了解详情", 8, _hoisted_15)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("img", {
                          src: item[1].img,
                          alt: "",
                          style: {"width":"120px","height":"160px"}
                        }, null, 8, _hoisted_18)
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, _toDisplayString(item[1].title), 1),
                        _createElementVNode("div", _hoisted_21, _toDisplayString(item[1].text), 1),
                        _createElementVNode("div", {
                          class: "tofile",
                          onClick: ($event: any) => (tofile(item[1].url

                                    ))
                        }, "了解详情", 8, _hoisted_22)
                      ])
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 512)
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createVNode(mytitle, {
        title: "政策背景",
        style: {"margin-top":"64px"}
      }),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", {
          class: "delStep",
          style: {"position":"absolute","left":"-55px","top":"278px"},
          onClick: delstep
        }, _hoisted_26),
        _createElementVNode("div", {
          class: "delStep",
          style: {"position":"absolute","right":"-55px","top":"278px"},
          onClick: addstep
        }, _hoisted_28),
        _createElementVNode("div", {
          class: "center",
          ref_key: "parentRef",
          ref: parentRef
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(yearList), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "stepBox",
              key: index,
              style: _normalizeStyle({ transform: `translateX(${-scrollOffset.value}px)` })
            }, [
              _createElementVNode("div", {
                class: "stepLine1",
                style: _normalizeStyle({ backgroundColor: _unref(nowStep) >= item.year ? ' #2544B3' : '#D6DBE3', })
              }, null, 4),
              _createElementVNode("div", _hoisted_29, [
                (index % 2 === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, _toDisplayString(item.title), 1),
                      _createElementVNode("div", {
                        class: "text",
                        innerHTML: item.text
                      }, null, 8, _hoisted_32)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, _toDisplayString(item.title), 1),
                      _createElementVNode("div", {
                        class: "text",
                        innerHTML: item.text
                      }, null, 8, _hoisted_35)
                    ])),
                _createElementVNode("div", _hoisted_36, _toDisplayString(item.year), 1),
                _createElementVNode("div", _hoisted_37, [
                  (_unref(nowStep) == item.year)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_38))
                    : (_openBlock(), _createElementBlock("img", _hoisted_39))
                ]),
                (_unref(nowStep) == item.year)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, _hoisted_42))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: "stepLine1",
                style: _normalizeStyle({ backgroundColor: _unref(nowStep) > item.year ? ' #2544B3' : '#D6DBE3' })
              }, null, 4)
            ], 4))
          }), 128))
        ], 512)
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_43, [
        _createVNode(mytitle, {
          title: "远程异地评标和评标专家库共享简介",
          color: "white",
          style: {"margin-top":"64px"}
        }),
        _hoisted_44
      ]),
      _hoisted_45,
      _createElementVNode("div", null, [
        _createElementVNode("section", null, [
          _createVNode(mytitle, { title: "接入指南" }),
          _createElementVNode("main", _hoisted_46, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(guides.value, (item, index) => {
              return (_openBlock(), _createBlock(_unref(StandardCard), {
                key: index,
                title: item.title,
                onPreview: ($event: any) => (previewGuide(item)),
                onDownload: ($event: any) => (downloadGuide(item))
              }, null, 8, ["title", "onPreview", "onDownload"]))
            }), 128))
          ])
        ])
      ])
    ]),
    _hoisted_47
  ]))
}
}

})